var _excluded = ["children", "dropdownTestId", "title", "footer"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Children } from 'react';
import { Typography } from '../../../../components/dataDisplay';
import { Box } from '../../../../components/internal';
import { forwardRef } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Container, Group } from '../../..';
import { useBaseMenuContext } from '../../../BaseMenu/hooks';
import { BottomSheet } from '../../../BottomSheet';
import { _MenuFooter } from '../_MenuFooter/_MenuFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var _MobileMenuDropdown = forwardRef((_ref, ref) => {
  var {
    children,
    dropdownTestId,
    title,
    footer
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var menuItemCount = Children.count(children);
  var hasItems = Boolean(menuItemCount);
  var styles = useMultiStyleConfig('_MobileMenuDropdown', {
    hasTitle: Boolean(title),
    hasItems
  });
  var {
    isOpen,
    setIsOpen,
    refs,
    getFloatingProps
  } = useBaseMenuContext();

  var footerComponent = !!(footer !== null && footer !== void 0 && footer.label) && /*#__PURE__*/_jsx(_MenuFooter, _objectSpread(_objectSpread({}, footer), {}, {
    children: typeof (footer === null || footer === void 0 ? void 0 : footer.children) === 'string' ? /*#__PURE__*/_jsx(Box, {
      children: footer === null || footer === void 0 ? void 0 : footer.children
    }) : footer.children
  }));

  return /*#__PURE__*/_jsx(BottomSheet, _objectSpread(_objectSpread({
    "data-component": "_MobileMenu"
  }, props), {}, {
    onClose: () => setIsOpen(false),
    isOpen: isOpen,
    "data-testid": dropdownTestId,
    ref: ref,
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      "data-testid": "mobile-menu-dropdown-menu-list",
      __css: styles['menuList'],
      ref: refs.setFloating
    }, getFloatingProps()), {}, {
      children: /*#__PURE__*/_jsxs(Group, {
        spacing: "xs",
        variant: "vertical",
        children: [title && /*#__PURE__*/_jsx(Box, {
          role: "menuitem",
          "aria-label": title,
          __css: styles['title'],
          children: /*#__PURE__*/_jsx(Typography.SectionLabel, {
            label: title
          })
        }), /*#__PURE__*/_jsx(Box, {
          __css: styles['items'],
          children: /*#__PURE__*/_jsxs(Group, {
            hasDivider: true,
            variant: "vertical",
            spacing: "none",
            children: [hasItems && /*#__PURE__*/_jsx(Group, {
              variant: "vertical",
              spacing: "xs",
              children: children
            }), footerComponent && /*#__PURE__*/_jsx(Container, {
              paddingTop: "m",
              paddingBottom: "xs",
              children: footerComponent
            })]
          })
        })]
      })
    }))
  }));
});
_MobileMenuDropdown.displayName = '_MobileMenuDropdown';
//# sourceMappingURL=_MobileMenuDropdown.js.map